import React, { useEffect, useState } from "react";
import { SquareArrowOutUpRight } from "lucide-react";
import "./CardBlog.css";
import { teacherAPI } from "../../../api/aulasApi";

function BlogCard() {
  const [news, setNews] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchNews = async () => {
      try {
        const response = await teacherAPI.getNews();
        setNews(response.data);
      } catch (error) {
        console.error("Erro ao buscar notícias:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchNews();
  }, []);

  if (loading) {
    return <p>Carregando notícias...</p>;
  }

  return (
    <div className="blog-card__wrapper">
      <div className="blog-card__container">
        {news.map((item, index) => (
          <div key={index} className="blog-card__item">
            <div className="blog-card__image-container">
              <img src={item.url_imagem} alt={item.titulo} className="blog-card__image" />
            </div>

            <div className="blog-card__content">
              <h3 className="blog-card__title">{item.titulo}</h3>
              <p className="blog-card__description">{item.descricao}</p>
            </div>

            <a href={item.link} className="blog-card__link" target="_blank" rel="noopener noreferrer">
              <SquareArrowOutUpRight className="blog-card__link-icon" size={20} />
            </a>
          </div>
        ))}
      </div>
    </div>
  );
}

export default BlogCard;
